import React, { useState, useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import { AppDispatch } from "../store/store";
//import Modernizr from "modernizr";
// import { setPkg } from "../store/reducers/publicSlice";

import { MDXRenderer } from 'gatsby-plugin-mdx';
import { MDXProvider } from "@mdx-js/react";

// import PrivacyPopup from "../components/PrivacyPopup";
// import { Link, useStaticQuery, graphql } from 'gatsby';
import { Link, useStaticQuery, graphql } from 'gatsby';

import Bubbles from '../components/3dbubbles';

import MainMenu from "../components/MainMenu";

// import { AnchorLink } from "gatsby-plugin-anchor-links";

type Props = {
    title: string;
    to: string,
};

type IContentPref = {
  className?: any;
  style?: any;
}

import SEO from '../components/SEO';

import Taglist from '../components/taglist';

const Template = ({location, data}: any) => {
  let dispatch: any = (action: any) => {};

  const [menuOpen, setMenuOpen] = useState<boolean>(false);
  const [videoAutoplay, setVideoAutoplay]= useState<undefined | boolean>(undefined);

  const { mdx } = data;
  //const { location } = data;
  const { frontmatter, body, headings, tableOfContents  } = mdx;

  const slugs = require('github-slugger')();
  const portFolioImages: string[][] = [];

  const ids: string[] = []; 

  if (typeof window !== 'undefined') {
    dispatch = useDispatch<AppDispatch>();
    if (location && location.hash) {
      /*if (location.hash === "#pkg1") {
        dispatch(setPkg(1));
      } else if (location.hash === "#pkg2") {
        dispatch(setPkg(2));
      } else if (location.hash === "#pkg3") {
        dispatch(setPkg(3));
      }*/
    }
  }

  function extractIdFromString(str: string) {
    let string = str.replace(/ +$/, '');
    let matched = string.match(/ {#([^]+?)}$/);
    if (matched) {
      let id = matched[1];
      if (!!id.length) {
        const nString = string.substring(0, matched.index);
        if (!ids.includes(id)) {
          ids.push(id);
          return {
            children: nString,
            id: id
          }
        }
        return {
          children: nString
        }
      }
    }
    return {children: str}
  }

  
  const MyH1 = props => {
    //let id = props.id ? slugs.slug(props.id, true) : slugs.slug(props.children.toString());
    //console.log('h1',props);

    return <h1 {...props} />
    /*return (<React.Fragment>
      <h1 {...props} />
      { frontmatter.keywords ?
        <Taglist tags={frontmatter.keywords} />
        : ""
      }
      { frontmatter.years ?
        <div className="year">{frontmatter.years.length === 2 ? frontmatter.years.join("–") : frontmatter.years.join(",")}</div>
        : ""
      }
    </React.Fragment>)*/
  };
  
  const MyH2 = props => {
    const childrenWithId = extractIdFromString(props.children.toString());
    if (childrenWithId.id) {
      props = {...props, id: childrenWithId.id, children: childrenWithId.children};
    } else {
      props = {...props, children: childrenWithId.children};
    }
    return <h2 {...props} />
  };

  function playVideo(id: string) {
    //console.log('id',id)
    const vid:any = document.getElementById(id);
    if (vid && vid.play) {
      vid.play();
    }
  }

  const Tags = () => {
    //return <React.Fragment />;
    return <Taglist tags={frontmatter.keywords} url={frontmatter.slug+"/"} />;
  }


  

  const components = {
    Tags: Tags,
    h1: MyH1,
    h2: MyH2,
  }


  let contentPrefs:IContentPref = {
    className: "about-page relative z-20",
  }
  
  let bgStyle = {}

  //if (frontmatter.colors?.bg) bgStyle = { backgroundColor: frontmatter.colors.bg};
  
  let content = (
    <React.Fragment>
      <div className="fixed z-0 main-content">
        <Bubbles />
      </div>
      <main {...contentPrefs}>
        <article className="article">
        <MDXProvider components={components}>
            <MDXRenderer headings={headings}>{body}</MDXRenderer>
        </MDXProvider>
        </article>
      </main>
    </React.Fragment>
  );

  let menuClass = "hidden";
  if (menuOpen === true) {
    menuClass = "h-screen";
  }

  let menuCenter = [];
  let menuRight = [
    <a href="/portfolio">Portfolio</a>
  ];


  if ( frontmatter.lang && frontmatter.lang === "en" ) {
    menuCenter = [];
    menuRight = [];
  }

  useEffect(() => {
    
  }, []);

  return (
    <React.Fragment>
      <SEO page={frontmatter} />
      <header className="page-header z-90">
        <div className="md:hidden absolute text-3xl cursor-pointer text-normal" onClick={() => setMenuOpen(!menuOpen)}>
            { menuOpen === true ? "x" : "=" }
        </div>
        <nav className="nav">
          <div className="flex-auto md:flex-initial text-center py-2">
            <div className="inline-block font-serif">
              <Link to={'/'} title="Lemonade Farm" className="mr-2 inline-block"> 
                <img src="/img/lemonade-farm-icon.svg" className="w-5 -mb-1" alt="Lemonade Farm" />
                {/*<img alt="LeadTrigger" className="logo" style={{width: 140, height: "auto"}} src="/img/leadtrigger.svg" />
                <img alt="LeadTrigger" className="logo" style={{width: 120, height: "auto"}} src="/img/lead-trigger.svg" />*/}
              </Link>
              
              <span className="font-sans">About: </span>
              <Link to={'/jussi-vanto'} title="About Jussi Vanto">
                Jussi Vanto
              </Link>
            </div>
          </div>
          <div className="wide-nav pt-2">
            {menuCenter.map((item, key: number) => <React.Fragment key={key}>{item}</React.Fragment>)}
          </div>
          <div className="hidden md:block text-right pt-2" /* md:w-24 */>
            {menuRight.map((item, key: number) => <React.Fragment key={key}>{item}</React.Fragment>)}
          </div>
        </nav>
        <MainMenu menuOpen={menuOpen} setMenuOpen={setMenuOpen} />
      </header>
      {content}
      {/*<footer className="page-footer flex w-full bg-primary-100 mt-20 bg-opacity-50">
        
        </footer>*/}
    </React.Fragment>
  );
}

export default Template;
